export default {
  tabs: [],
  currentTab: null,
  currentTabId: null,
  untitledLastIndex: 0,
  inquiries: [],
  predefinedInquiries: [],
  loadingPredefinedInquiries: false,
  predefinedInquiriesLoaded: false,
  db: null,
  isWorkspaceVisible: false
}
